import ResolveFromCondition from "../ResolveFromCondition/ResolveFromCondition";
import { ModuleConditionTypeEnum } from "@/includes/logic/Modules/types";

export default class ResolveFromXpCondition extends ResolveFromCondition {
  type: ModuleConditionTypeEnum = ModuleConditionTypeEnum.ResolveFromXp;
}
